import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SeniorityLevel } from "../../seniority/ManageSeniority";
import { Control } from "react-hook-form";
import InputMask from "react-input-mask";
import { CitySelector } from "@/components/ui/city-selector";

interface BasicInformationFormProps {
  control: Control<any>;
  seniorityLevels?: SeniorityLevel[];
}

export const BasicInformationForm = ({
  control,
  seniorityLevels,
}: BasicInformationFormProps) => {
  return (
    <>
      <CardHeader>
        <CardTitle>Basic Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={control}
          name="firstName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="lastName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Last Name</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="phoneNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Phone</FormLabel>
              <FormControl>
                <InputMask
                  mask="(999) 999-9999"
                  maskChar="_"
                  value={field.value || ""}
                  onChange={field.onChange}
                >
                  {(
                    inputProps: React.InputHTMLAttributes<HTMLInputElement>,
                  ) => (
                    <Input
                      {...inputProps}
                      type="tel"
                      placeholder="(555) 555-5555"
                    />
                  )}
                </InputMask>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>City</FormLabel>
              <FormControl>
                <CitySelector
                  value={field.value || ""}
                  onValueChange={field.onChange}
                  placeholder="Select city..."
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="seniorityLevelId"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Select Seniority Level</FormLabel>
              <Select onValueChange={field.onChange} value={field.value || ""}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a level" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {seniorityLevels &&
                    seniorityLevels.map((level) => (
                      <SelectItem value={level.id} key={level.id}>
                        {level.description}
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </>
  );
};
